import api from "./api";
import type {
  DeadlineItem, DeadlineRule, DeadlineSummary, CustomRuleInput,
} from "@/types/legalDeadline";

class LegalDeadlineService {
  private base = "/legal-deadlines";

  // ----- 항목 (체크리스트) -----
  async listItems(params?: {
    status?: string; event_type?: string; user_id?: string; ensure?: boolean;
  }): Promise<DeadlineItem[]> {
    const r = await api.get(`${this.base}/items`, { params });
    return r.data;
  }
  async completeItem(id: number, data: { note?: string }): Promise<void> {
    await api.post(`${this.base}/items/${id}/complete`, data);
  }
  async dismissItem(id: number, data: { reason: string }): Promise<void> {
    await api.post(`${this.base}/items/${id}/dismiss`, data);
  }
  async reopenItem(id: number, data: { reason?: string }): Promise<void> {
    await api.post(`${this.base}/items/${id}/reopen`, data);
  }
  // 근로계약서 스캔본 업로드 → 직원 문서함(근로계약서 구분) 저장 + 항목 자동 완료
  async uploadContractScan(id: number, file: File): Promise<{ auto_completed: number }> {
    const form = new FormData();
    form.append("file", file);
    const r = await api.post(`${this.base}/items/${id}/upload-contract`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return r.data;
  }

  // ----- 규칙 + 설정 -----
  async listRules(): Promise<DeadlineRule[]> {
    const r = await api.get(`${this.base}/rules`);
    return r.data;
  }
  async updateRuleSetting(ruleId: number, data: {
    is_enabled?: boolean | null;
    deadline_days_override?: number | null;
    deadline_day_override?: number | null;
    notify_days_override?: number[] | null;
    params_override?: Record<string, any> | null;
    note?: string | null;
  }): Promise<void> {
    await api.put(`${this.base}/rules/${ruleId}/settings`, data);
  }
  async createCustomRule(data: CustomRuleInput): Promise<DeadlineRule> {
    const r = await api.post(`${this.base}/rules`, data);
    return r.data;
  }
  async updateCustomRule(ruleId: number, data: Partial<CustomRuleInput> & { is_active?: boolean }): Promise<void> {
    await api.put(`${this.base}/rules/${ruleId}`, data);
  }
  async deleteCustomRule(ruleId: number): Promise<void> {
    await api.delete(`${this.base}/rules/${ruleId}`);
  }

  // ----- 집계/배지/수동 점검 -----
  async pendingCount(): Promise<{ count: number }> {
    const r = await api.get(`${this.base}/pending-count`);
    return r.data;
  }
  async summary(): Promise<DeadlineSummary> {
    const r = await api.get(`${this.base}/summary`);
    return r.data;
  }

  async refresh(): Promise<{ created: number; auto_completed: number }> {
    const r = await api.post(`${this.base}/refresh`);
    return r.data;
  }
}

const legalDeadlineService = new LegalDeadlineService();
export default legalDeadlineService;
